(function() {
  'use strict';

  angular.module('eclipseApp.core').factory('httpService', ['$http', 'uteEndpoint', function ($http, uteEndpoint) {
  var service = {};

  service.send = function (endpoint, params) {
    var request = {
      method : params.httpMethod || 'POST',
      url : uteEndpoint(endpoint),
      data : params,
      cache : angular.isDefined(params.cache) ? params.cache : false
    };

    console.log('-- "' + endpoint + '" REQUEST: ', request);

    var promise = $http(request);

    promise.then(onSuccess, onFailure);

    return promise;
  };

  function onSuccess(result) {
    //console.log('-- "' + result.config.url + '" SUCCESS: ', result);
  }

  function onFailure(error) {
    var method = error.config && error.config.url || 'UNKNOWN';
    console.log('-- "' + method + '" FAIL: ');
    console.error(error);
  }

  return service;
}]);
}());
